import { motion } from "framer-motion";
import { RotateCcw, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AnswersDialog } from "./answers-dialog";

interface Answer {
  index: number;
  selectedOption: string;
  questionText: string;
  answerText: string;
}

interface Position {
  id: number;
  name: string;
  description: string;
}

interface ResultSectionProps {
  streamingText: string;
  isStreaming: boolean;
  answers: Answer[];
  selectedPositionInfo: Position | undefined;
  showAnswersDialog: boolean;
  onShowAnswersDialogChange: (show: boolean) => void;
  onRestart: () => void;
}

export function ResultSection({
  streamingText,
  isStreaming,
  answers,
  selectedPositionInfo,
  showAnswersDialog,
  onShowAnswersDialogChange,
  onRestart,
}: ResultSectionProps) {
  return (
    <motion.div
      key="result"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="space-y-6"
    >
      <div className="text-center space-y-4">
        <div className="flex items-center justify-center space-x-2">
          <Sparkles className="w-8 h-8 text-yellow-500" />
          <h1 className="text-3xl font-bold text-white">AI 锐评结果</h1>
          <Sparkles className="w-8 h-8 text-yellow-500" />
        </div>
      </div>

      {/* AI分析结果 */}
      <Card className="w-full">
        <CardHeader>
          <CardTitle className="flex items-center space-x-2">
            <Sparkles className="w-5 h-5 text-yellow-500" />
            <span>AI 锐评分析</span>
            {isStreaming && (
              <div className="flex items-center space-x-2 text-sm text-gray-400">
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-yellow-500" />
                <span>正在生成...</span>
              </div>
            )}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="prose prose-invert max-w-none">
            <div className="whitespace-pre-wrap text-foreground/80 leading-relaxed">
              {streamingText}
              {isStreaming && (
                <span className="inline-block w-1 h-5 bg-yellow-500 animate-pulse duration-500 ml-1 -mb-[3px]" />
              )}
            </div>
          </div>
        </CardContent>
      </Card>

      {!isStreaming && (
        <div className="text-center space-x-4">
          <AnswersDialog
            answers={answers}
            selectedPositionInfo={selectedPositionInfo}
            open={showAnswersDialog}
            onOpenChange={onShowAnswersDialogChange}
          />

          <Button onClick={onRestart} size="lg" className="px-3">
            <RotateCcw className="w-4 h-4" />
            重新测试
          </Button>
        </div>
      )}
    </motion.div>
  );
}
